var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":"is-primary","loading":_vm.loadingButtonReportPdf,"icon-left":"download"},on:{"click":_vm.generatePdf}},[_vm._v("Descargar")])}
var staticRenderFns = []

export { render, staticRenderFns }